import {Container, Singleton} from 'typescript-ioc'
import BaseApi from '@/api/BaseApi'
import FirmwareConfig from "@/model/FirmwareConfig";
import {FconfigEditForm} from "@/form/FirmwareConfigForm";

@Singleton
export default abstract class FirmwareConfigApi {
    abstract query(productId: number): Promise<FirmwareConfig>

    abstract edit(form: FconfigEditForm): Promise<FirmwareConfig>
}

class FirmwareConfigApiImpl extends BaseApi implements FirmwareConfigApi {

    protected urlPrefix = 'firmware/config'

    query(productId: number): Promise<FirmwareConfig> {
        return this.axios.get('query', {params: {productId: productId}})
    }

    edit(form: FconfigEditForm): Promise<FirmwareConfig> {
        return this.axios.post('edit', form)
    }
}

Container.bind(FirmwareConfigApi).to(FirmwareConfigApiImpl)
